import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ShowCard from '@/components/feature/ShowCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, getHotShows, getLatestShows } from '@/mocks/shows';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '天天影视',
  url: 'https://tiantian.tv',
  description: '天天影视综艺节目，热门综艺真人秀在线观看，娱乐视频，高清免费，不缓冲，综艺大全在线看，天天更新。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://tiantian.tv/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '天天影视',
  url: 'https://tiantian.tv',
  description: '天天影视致力于提供最新最全的综艺节目在线观看服务',
  sameAs: ['https://weibo.com/tiantiantv', 'https://space.bilibili.com/tiantiantv'],
};

const hotShows = getHotShows(8);
const latestShows = getLatestShows(8);
const heroShow = hotShows[0];

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <div className="min-h-screen bg-background-50 flex flex-col">
        <Navbar />

        <main>
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20TV%20studio%20stage%20with%20colorful%20vibrant%20lights%20and%20modern%20LED%20screens%20showing%20variety%20show%20content%20dynamic%20atmosphere%20professional%20broadcast%20studio%20warm%20orange%20and%20gold%20tones%20cinematic%20lighting&width=1800&height=900&seq=hero-bg-tiantian&orientation=landscape"
              alt="天天影视 - 综艺节目在线观看"
              title="天天影视综艺节目，热门综艺真人秀在线观看"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

            <div className="absolute inset-0 flex flex-col items-center justify-center px-4">
              <div className="text-center max-w-3xl w-full">
                <h1 className="text-3xl md:text-5xl font-heading text-white mb-4 leading-tight">
                  天天影视 - 热门综艺在线观看
                </h1>
                <p className="text-sm md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
                  高清免费 · 流畅不缓冲 · 综艺大全在线看 · 天天更新
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <Link
                    to={`/article/${heroShow.id}`}
                    className="whitespace-nowrap px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm transition-all cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-play-circle-line text-lg"></i>
                    立即观看热门综艺
                  </Link>
                  <Link
                    to="/category/all"
                    className="whitespace-nowrap px-8 py-3 bg-white/15 hover:bg-white/25 text-white backdrop-blur-sm rounded-full text-sm transition-all cursor-pointer border border-white/20"
                  >
                    浏览全部综艺
                  </Link>
                </div>
                <div className="flex items-center justify-center gap-6 mt-8 text-white/60 text-xs">
                  <span className="flex items-center gap-1"><i className="ri-checkbox-circle-line"></i> 高清画质</span>
                  <span className="flex items-center gap-1"><i className="ri-speed-line"></i> 流畅不缓冲</span>
                  <span className="flex items-center gap-1"><i className="ri-refresh-line"></i> 天天更新</span>
                  <span className="flex items-center gap-1"><i className="ri-vip-crown-line"></i> 免费观看</span>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-[1280px] mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-lg md:text-xl font-heading text-foreground-900">综艺分类</h2>
                <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1">
                  查看全部 <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
                {categories.filter(c => c.slug !== 'all').map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
                  >
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                      <i className={`${cat.icon} text-lg`}></i>
                    </div>
                    <span className="text-xs md:text-sm text-foreground-700 group-hover:text-primary-500 transition-colors font-medium whitespace-nowrap">
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-[1280px] mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-lg md:text-xl font-heading text-foreground-900">热门推荐</h2>
                  <p className="text-sm text-foreground-500 mt-1">评分最高的综艺节目精选</p>
                </div>
                <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1">
                  更多 <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {hotShows.map((show) => (
                  <ShowCard key={show.id} show={show} />
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-[1280px] mx-auto">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-lg md:text-xl font-heading text-foreground-900">最新更新</h2>
                  <p className="text-sm text-foreground-500 mt-1">第一时间观看最新综艺节目</p>
                </div>
                <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1">
                  更多 <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {latestShows.map((show) => (
                  <ShowCard key={show.id} show={show} />
                ))}
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-[1280px] mx-auto">
              <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center text-white">
                <h2 className="text-2xl md:text-3xl font-heading mb-3">追综不停，精彩继续</h2>
                <p className="text-white/80 mb-6 max-w-lg mx-auto text-sm md:text-base">
                  天天影视每天更新热门综艺节目，高清免费，流畅不缓冲。加入我们，发现更多精彩内容！
                </p>
                <Link
                  to="/category/all"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 bg-white text-primary-600 rounded-full font-medium text-sm hover:bg-white/90 transition-colors cursor-pointer"
                >
                  <i className="ri-play-list-2-line text-base"></i>
                  立即探索全部综艺
                </Link>
              </div>
            </div>
          </section>

          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-[1280px] mx-auto">
              <h2 className="text-lg md:text-xl font-heading text-foreground-900 mb-6 text-center">为什么选择天天影视</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
                <div className="text-center p-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-hd-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">高清画质</h3>
                  <p className="text-xs text-foreground-500">1080P超清画质，沉浸式观看体验</p>
                </div>
                <div className="text-center p-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                    <i className="ri-speed-up-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">流畅不缓冲</h3>
                  <p className="text-xs text-foreground-500">CDN加速，全国多节点覆盖</p>
                </div>
                <div className="text-center p-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-calendar-check-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">天天更新</h3>
                  <p className="text-xs text-foreground-500">每日同步最新综艺，精彩不停</p>
                </div>
                <div className="text-center p-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 mb-1">正版授权</h3>
                  <p className="text-xs text-foreground-500">正版内容授权，安心观看</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}